<section>
	<ui-heading-content-block
		[heading]="heading"
		[subheading]="subheading"
		[headingLevel]="headingType"
		[intro]="content"
	></ui-heading-content-block>
</section>
